import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const IconButton = ({ onClick, src }) => {
  return (
    <Icon onClick={onClick}>
      <img src={src} />
    </Icon>
  );
};

const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  outline: none;
  &:hover {
    cursor: pointer;
  }
`;

IconButton.propTypes = {
  onClick: PropTypes.func,
};

export default IconButton;
